import { API_MAP, agent } from 'helpers';

class ConfirmationService {
  public changeCoproducerStatus(values: { k: string; status: string }) {
    return agent.post(`${API_MAP.moderateCoproducers}`, values);
  }
}

export const confirmationService = new ConfirmationService();
